import React from 'react'
import ReactMarkdown from 'react-markdown'
import intl from 'react-intl-universal'
import { Navigation } from '@raysync/common/services'
import { formatDate } from '@raysync/common/utils'
import { SEO as Seo, LargeWrapper, H2, Button, ShowAtMobile } from '@raysync/common/components'
import { useMarkdownNavigation } from '@raysync/common/hooks'
import Layout from '../components/layout'
import BreadCrumb from '../components/post/bread-crumb'
import { CmsPostContainer } from '../components/main/cms'
import CmsContentService from '../services/cms-content-service'
import { CardList } from '../components/main/card-list'
import {
  PostWrapper,
  PostContent,
  PostDate,
  PostShare,
  HotNewsTitle,
  PostContainer,
  NavigationWrap,
  NavigationBox,
  InviteBox,
  HeaderItem,
  PostTitle,
  HotNewsContainer,
} from '../style/post.atom'
import { ReactComponent as FacebookIcon } from '../images/facebook.svg'
import { ReactComponent as TwitterIcon } from '../images/twitter.svg'
import { ReactComponent as TableIcon } from '../images/table.svg'

const CodeBlock = props => {
  return <span dangerouslySetInnerHTML={{ __html: props.value }}></span>
}

const InviteContent = () => (
  <InviteBox>
    <p>
      Enterprise <span>High Speed</span> Large File Transfer Solutions
    </p>
    <div>
      <Button
        size='large'
        fullWidth
        onClick={() => {
          Navigation.toApply({ isInternal: false })
        }}
      >
        Request a Free Demo
      </Button>
      <Button
        size='large'
        fullWidth
        variant='outlined'
        onClick={() => {
          Navigation.to({ link: '/pricing/', isInternal: false })
        }}
      >
        View Pricing
      </Button>
    </div>
  </InviteBox>
)
function PostPage({ location, pageContext }) {
  const { headers, activeId, jumpTo } = useMarkdownNavigation('post-content')
  const currentHeaders = headers.filter(header => header.level === '2' || header.level === '3')

  const { title, slug, date, coverImage, content, seoTitle, keywords, description, hotNews, category } = pageContext
  const currentSeoTitle = seoTitle || title || intl.get('news.seo.title', { title: 'News' })
  const coverImgSrc = coverImage ? coverImage.file.url : CmsContentService.getCoverImg(content)
  return (
    <Layout location={location}>
      <Seo
        title={currentSeoTitle}
        description={description || intl.get('news.seo.desc')}
        keywords={keywords || intl.get('news.seo.keywords')}
        ogImage={coverImgSrc}
      />
      <PostWrapper>
        <LargeWrapper>
          <BreadCrumb slug={slug} title={title} category={category}></BreadCrumb>
          <PostContainer>
            <NavigationWrap>
              <NavigationBox>
                <p>
                  <TableIcon />
                  Content Table
                </p>
                {currentHeaders.length > 0 ? (
                  <ul>
                    {currentHeaders.map(header => (
                      <HeaderItem
                        key={header.id}
                        actived={header.id === activeId}
                        isSub={header.level === '3'}
                        onClick={() => {
                          jumpTo(header.id)
                        }}
                      >
                        {header.text}
                      </HeaderItem>
                    ))}
                  </ul>
                ) : null}
              </NavigationBox>
            </NavigationWrap>
            <PostContent>
              <PostTitle>{title}</PostTitle>
              <PostDate>{formatDate(date)}</PostDate>
              <CmsPostContainer>
                <div id='post-content'>
                  <ReactMarkdown
                    source={CmsContentService.formatHtmlContent(content)}
                    escapeHtml={false}
                    renderers={{ code: CodeBlock }}
                  />
                </div>
              </CmsPostContainer>
              <PostShare>
                {intl.get('news.post.share-this')}
                <a
                  href={`https://www.facebook.com/sharer/sharer.php?u=https://www.raysync.io${location.pathname}`}
                  target='_blank'
                  rel='noreferrer'
                >
                  <FacebookIcon />
                </a>
                <a
                  href={`http://twitter.com/share?url=https://www.raysync.io${location.pathname}`}
                  target='_blank'
                  rel='noreferrer'
                >
                  <TwitterIcon />
                </a>
              </PostShare>
            </PostContent>
            <NavigationWrap>
              <InviteContent />
            </NavigationWrap>
          </PostContainer>
          <HotNewsContainer>
            <HotNewsTitle>{intl.get('news.like')}</HotNewsTitle>
            <CardList data={hotNews} slug={category.slug} isHotCard />
          </HotNewsContainer>
          <ShowAtMobile>
            <InviteContent />
          </ShowAtMobile>
        </LargeWrapper>
      </PostWrapper>
    </Layout>
  )
}

export default PostPage
